import Bolt from "@mui/icons-material/Bolt";
import Favorite from "@mui/icons-material/Favorite";
import Shield from "@mui/icons-material/Shield";
import { Box, ButtonBase, Typography, useTheme } from "@mui/material";
import React from "react";

import useProcedureTabs from "components/pages/dashboard/surgery_types_procedures/procedures/useProcedureTabs";

const PROCEDURE_ICONS = {
  shield: Shield,
  heart: Favorite,
  bolt: Bolt,
};

const ProcedureTabs = () => {
  const theme = useTheme();
  const { tabs, activeProcedureId, onSelect } = useProcedureTabs();

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
      <Box
        role="tablist"
        sx={{
          display: "inline-flex",
          gap: 0.5,
          p: 0.5,
          borderRadius: "10px",
          bgcolor: theme.palette.grey[100],
          border: `1px solid ${theme.palette.border.main}`,
        }}
      >
        {tabs.map(({ id, name, icon }) => {
          const Icon = PROCEDURE_ICONS[icon];
          const isActive = id === activeProcedureId;

          return (
            <ButtonBase
              key={id}
              role="tab"
              aria-selected={isActive}
              onClick={() => onSelect(id)}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 3,
                py: 1.25,
                borderRadius: "8px",
                bgcolor: isActive
                  ? theme.palette.secondary.main
                  : "transparent",
                color: isActive
                  ? theme.palette.secondary.contrastText
                  : theme.palette.text.primary,
                transition: theme.transitions.create([
                  "background-color",
                  "color",
                ]),
                "&:hover": {
                  bgcolor: isActive
                    ? theme.palette.secondary.main
                    : theme.palette.action.hover,
                },
              }}
            >
              {Icon && (
                <Icon
                  fontSize="small"
                  sx={{
                    color: isActive ? "inherit" : theme.palette.lightText.main,
                  }}
                />
              )}
              <Typography
                component="span"
                sx={{ fontSize: "1rem", fontWeight: 500 }}
              >
                {name}
              </Typography>
              {isActive && (
                <Box
                  component="span"
                  sx={{
                    width: 8,
                    height: 8,
                    ml: 0.5,
                    borderRadius: "50%",
                    bgcolor: theme.palette.common.white,
                  }}
                />
              )}
            </ButtonBase>
          );
        })}
      </Box>
    </Box>
  );
};

export default ProcedureTabs;
